import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import MoreVert from '@material-ui/icons/MoreVert'
import PropTypes from 'prop-types'

const styles = {
  root: {
    padding: 0
  }
}

class LayerMenuButton extends React.PureComponent {
  render = () => {
    const { classes, show, onClick, titleid } = this.props

    // console.debug('LayerMenuButton - render', titleid)

    if (!show) {
      console.debug(`LayerMenuButton render - layer not visible for '${titleid}'. Not rendering menu button.`)
      return null
    }

    const iconButton = (
      <IconButton
        disabled={false}
        className={classes.root}
        aria-label="Open layer menu"
        onClick={onClick}
        size="small">
        <MoreVert />
      </IconButton>
    )

    return iconButton
  }
}

LayerMenuButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  titleid: PropTypes.string.isRequired
}

export default (
  withStyles(styles)(LayerMenuButton)
)
